<style lang="scss">
.GameCreditOutputMudul {
    .ctrl {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px 12px;
    }
}
</style>
<template>
    <el-dialog class="GameCreditOutputMudul" :title="title" :visible.sync="view" :size="'bhuge'" top="5vh" :modal-append-to-body="false">
        <div class="ctrl l-flex-1 o-mb-s">
            <span class="o-pl">游戏类型：</span>
            <el-select v-model="Filter.games_id" style="width:6.5rem;" size="small">
                <el-option v-for="(item,index) in Opt.hasDir.game" :key="item.id" :label="item.title" :value="item.id" @click.native="ChangeGame(item)" />
            </el-select>
            <DatePicker v-model="Filter.interval" single @change="Reload()" />
        </div>
        <history ref="history" :filter="Filter" />
    </el-dialog>
</template>

<script>
import StoreMix from '@lottery.2.0/mixin/store.modul.js'
import SixMix from '@lottery.admin.2.0/mixin/six.js'
import History from '../components/history'
export default {
    name: 'MCreditSixOutput',
    mixins: [StoreMix, SixMix],
    data() {
        return {
            store: 'game/history',
            Filter: {
                games_id: 37,
                games_type: 7,
                per_page: 20,
                interval: null
            }
        }
    },
    methods: {
        init() {
            this.Filter.games_id = this.Running.id
            this.Filter.games_type = this.Running.group
            this.Reload()
        },
        Reload() {
            if (this.$refs.history && this.$refs.history.reload) {
                this.$refs.history.reload()
            }
        },
        ChangeGame(item) {
            this.Filter.games_id = item.id
            this.Filter.games_type = item.type
            this.Reload()
        }
    },
    components: {
        History
    },
    mounted() {
        this.init()
    }
}
</script>
